<template>
    <el-card class="quick_matter common_matter" shadow="never">
        <div class="title">
            <p>便捷入口</p>
            <el-select v-model="quickValue" class="title_dropdown">
                <el-option v-for="(item,i) in quickList" :key="i" :value="item.value" :label="item.text"></el-option>
            </el-select>
        </div>
        <div class="quick_matter--con" @click="deleteFlag=false">
            <div class="quick_matter--con--btns">
                <span @click.stop="addQuick">添加</span>&nbsp;|
                <span @click.stop="deleteFlag=true">删除</span>
            </div>
            <div class="drag_con">
                <!-- <draggable v-model="quickData" forceFallback="true" delay="100" animation="500" @end="quickDragEnd"></draggable> -->
                <div class="item clearfix" v-for="(item,i) in quickData" :key="i" :title="item.systemName" @click="quickLink(item)">
                    <span>{{item.systemName}}</span>
                    <div class="go_icon" v-if="!deleteFlag"></div>
                    <div class="delete" v-if="deleteFlag" @click.stop="quickDeleteHandle(item)"></div>
                </div>
            </div>
        </div>
    </el-card>
</template>

<script>
import draggable from 'vuedraggable'
import {quickList} from '@/utils/busyness';
import {apiwbconveniententrancedelete,apiwbconveniententrancedeleteCustomize} from '@/server/common';
export default {
    data(){
        return {
            quickList:quickList,
            quickValue:'',
            deleteFlag:false,
            quickData:[{systemName:'产权监督系统',systemType:'1'},{systemName:'产权监督系统',systemType:'1'},{systemName:'产权监督系统',systemType:'1'},{systemName:'产权监督系统',systemType:'1'},{systemName:'产权监督系统',systemType:'1'}]
        }
    },
    created(){},
    methods:{
        fetchData(){},
        addQuick(){},
        quickDeleteHandle(item){//便捷入口删除处理
            this.$confirm('是否删除本条记录？','提示',{
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(()=>{
                item.customizeStatus==0&&apiwbconveniententrancedelete({id:item.id}).then(({data})=>{
					if(data.code=='1'){
						this.fetchData();
					}else{
						this.$message.error(data.msg)
					}
				})
				item.customizeStatus==1&&apiwbconveniententrancedeleteCustomize({id:item.id,systemConfigId:item.systemConfigId}).then(({data})=>{
					if(data.code=='1'){
						// this.apiwbconveniententranceconvenientEntranceList();
					}else{
						this.$message.error(data.msg)
					}
				})
            }).catch(()=>{})
        }
    }
}
</script>

<style lang="less" scoped>
.quick_matter{
    height: 100%;
    /deep/ .el-card__body{
        height: 100%;
    }
    .title{
        .title_dropdown{
            margin-left: auto;
            width: 150px;
        }
    }
    .quick_matter--con{
        height: calc(100% - 50px);
        padding: 16px;
        overflow: auto;
        .quick_matter--con--btns{
            text-align: right;
            color: #EEEEEE;
            margin: 0 5px 16px 0;
            span{
                color: #1890FF;
                cursor: pointer;
                margin: 0 5px;
                &:hover{
                    opacity: .85;
                }
            }
        }
        .drag_con{
            padding: 0 0 10px;
            height: calc(100% - 30px);
            .item{
                width: calc(50% - 8px);
                min-width: 128px;
                padding: 12px 32px 12px 10px;
                margin: 0 16px 16px 0;
                background: #EFF3F6;
                cursor: pointer;
                border-radius: 3px;
                display: flex;
                align-items: center;
                position: relative;
                border: 1px solid #EFF3F6;
                float: left;
                position: relative;
                height: 48px;
                box-sizing: border-box;
                &:nth-last-of-type(-n+2) {
                    margin-bottom: 0;
                }
                .go_icon{
                    width: 16px;
                    height: 16px;
                    position: absolute;
                    right: 10px;
                    top: 50%;
                    transform: translate(0,-50%);
                    background: url('../../../../assets/images/home/goto_default.png') no-repeat;
                }
                &:hover{
                    border: 1px solid #1890FF;
                    color: #1890FF;
                }
                &:nth-child(even){
                    margin-right: 0;
                }
                span{
                    display: inline-block;
                    width: 100%;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }
                .my_icon{
                    margin-right: 10px;
                }
                &:hover .go_icon{
                    background: url('../../../../assets/images/home/goto_hover.png') no-repeat;
                }
                .delete{
                    width: 42px;
                    height: 42px;
                    position: absolute;
                    right: 0;
                    top: -1px;
                    border-radius: 0px 3px 3px 0px;
                    background: rgba(255, 0, 0, 0.4) url('../../../../assets/images/home/delete_icon.png') no-repeat;
                    background-position: center center;
                }
            }
        }
    }
}
</style>